import { FormControl, Grid, TextField } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { FunctionComponent } from 'react'
import { Controller, UseFormReturn } from 'react-hook-form'

import FormSelect from '../../../base/components/Form/FormSelect'
import { SucursalProps } from '../../../interfaces/sucursal'
import { apiSucursales } from '../api/apiSucursal'
import { AlmacenInputProps } from '../interfaces'

interface OwnProps {
  form: UseFormReturn<AlmacenInputProps>
}

type Props = OwnProps

/**
 * Formulario para upsert de almacenes
 * @param props
 * @constructor
 */
const AlmacenForm: FunctionComponent<Props> = (props) => {
  const {
    form: {
      control,
      formState: { errors },
    },
  } = props

  const { data: sucursales } = useQuery<SucursalProps[], Error>({
    queryKey: ['sucursales'],
    queryFn: apiSucursales,
  })
  return (
    <>
      <form>
        <Grid container spacing={2}>
          <Grid size={12}>
            <Controller
              name="codigoSucursal"
              control={control}
              render={({ field }) => (
                <FormControl
                  fullWidth
                  sx={{ md: 1 }}
                  error={Boolean(errors.codigoSucursal)}
                >
                  <FormSelect<SucursalProps>
                    inputLabel="Sucursal"
                    placeholder={'Seleccione la Sucursal'}
                    options={sucursales}
                    value={field.value}
                    onChange={field.onChange}
                    getOptionValue={(option) => option.codigo.toString()}
                    getOptionLabel={(value) => `${value.codigo} - ${value.direccion}`}
                    required
                    error={Boolean(errors.codigoSucursal)}
                    formHelperText={errors.codigoSucursal?.message || ''}
                  />
                </FormControl>
              )}
            />
          </Grid>
          <Grid size={12}>
            <Controller
              name="nombre"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Nombre"
                  size="small"
                  fullWidth
                  error={!!errors.nombre}
                  helperText={errors.nombre && errors.nombre.message?.toString()}
                />
              )}
            />
          </Grid>
          <Grid size={12}>
            <Controller
              name="ubicacion"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Ubicación"
                  size="small"
                  fullWidth
                  error={!!errors.ubicacion}
                  helperText={errors.ubicacion && errors.ubicacion.message?.toString()}
                />
              )}
            />
          </Grid>
        </Grid>
      </form>
    </>
  )
}

export default AlmacenForm
